import wordList from '../constants/wordlistdictionary.txt';
import { localDevWarn } from './debug/localDevLogger';

let dictionarySet = null;

// Initialize the dictionary set
const initDictionary = async () => {
  if (dictionarySet) return;
  
  try {
    const response = await fetch(wordList);
    const text = await response.text();
    // Create a Set of words for O(1) lookup
    dictionarySet = new Set(text.split('\n').map(word => word.trim()).filter(Boolean));
  } catch (error) {
    console.error('Error loading dictionary:', error);
    dictionarySet = new Set();
  }
};

// Check if a word exists in the dictionary
export const isValidWord = (word) => {
  if (!dictionarySet) {
    localDevWarn('Dictionary not initialized');
    return false;
  }
  return dictionarySet.has(word.toLowerCase());
};

export { initDictionary }; 